export class UserInfo {
    id?: string;
    token?: string;
    email?: string;
    verified?: boolean;
    iin?: string;
    lastName?: string;
    firstName?: string;
    fatherName?: string;
    roles?: string[];
}
